<template>
  <div class="row">
    <div v-if="description" class="col-md-4" v-html="description"></div>
    <div class="col">
      <div class="row" v-for="question in questions" :key="question.id">
        <div v-if="question.label" class="col-12" v-html="question.label"></div>
        <div v-if="question.description" class="col-12">
          <p v-html="question.description"></p>
        </div>
        <div class="col-12">
          <div class="row justify-content-between">
            <div class="col-12 col-lg-4">
              <!--p class="hand-written" style="font-size: 0.75em">{{question.original}}</p-->
              <p class="hand-written">{{ question.original }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <input
                tabindex="1"
                type="text"
                class="form-control"
                :id="'textArea' + question.id"
                v-model="question.response"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyboardingQuestionSingleLine'
}
</script>
